module.exports = __webpack_public_path__ + "static/media/yellow-fever-badge.5697b11a.png";